/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CategoryLookupResponseDto,
  CreateCategoryLookupDto,
  UpdateCategoryLookupDto,
} from '../models/index';
import {
    CategoryLookupResponseDtoFromJSON,
    CategoryLookupResponseDtoToJSON,
    CreateCategoryLookupDtoFromJSON,
    CreateCategoryLookupDtoToJSON,
    UpdateCategoryLookupDtoFromJSON,
    UpdateCategoryLookupDtoToJSON,
} from '../models/index';

export interface CreateCategoryRequest {
    createCategoryLookupDto: CreateCategoryLookupDto;
}

export interface GetAllCategoriesRequest {
    isActive?: boolean;
}

export interface UpdateCategoryRequest {
    id: number;
    updateCategoryLookupDto: UpdateCategoryLookupDto;
}

/**
 * 
 */
export class CategoryLookupServiceApi extends runtime.BaseAPI {

    /**
     */
    async createCategoryRaw(requestParameters: CreateCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CategoryLookupResponseDto>> {
        if (requestParameters['createCategoryLookupDto'] == null) {
            throw new runtime.RequiredError(
                'createCategoryLookupDto',
                'Required parameter "createCategoryLookupDto" was null or undefined when calling createCategory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/category-lookup/categories`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateCategoryLookupDtoToJSON(requestParameters['createCategoryLookupDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CategoryLookupResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async createCategory(requestParameters: CreateCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CategoryLookupResponseDto> {
        const response = await this.createCategoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAllCategoriesRaw(requestParameters: GetAllCategoriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CategoryLookupResponseDto>>> {
        const queryParameters: any = {};

        if (requestParameters['isActive'] != null) {
            queryParameters['isActive'] = requestParameters['isActive'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/category-lookup/categories`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CategoryLookupResponseDtoFromJSON));
    }

    /**
     */
    async getAllCategories(requestParameters: GetAllCategoriesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CategoryLookupResponseDto>> {
        const response = await this.getAllCategoriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateCategoryRaw(requestParameters: UpdateCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CategoryLookupResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateCategory().'
            );
        }

        if (requestParameters['updateCategoryLookupDto'] == null) {
            throw new runtime.RequiredError(
                'updateCategoryLookupDto',
                'Required parameter "updateCategoryLookupDto" was null or undefined when calling updateCategory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/category-lookup/categories/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateCategoryLookupDtoToJSON(requestParameters['updateCategoryLookupDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CategoryLookupResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async updateCategory(requestParameters: UpdateCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CategoryLookupResponseDto> {
        const response = await this.updateCategoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
